import { Flex, Text } from '@mantine/core'
import { useEffect, useState } from 'react'
// import DateAndFullNameColumn from '@components/table/DateAndFullNameColumn'
import TableViewButton from '@components/button/TableViewButton.'
import TableEditButton from '@components/button/TableEditButton'
import TableDeleteButton from '@components/button/TableDeleteButton'
import TablePagination from '@components/table/template/TablePagination'
import TableTemplate from '@components/table/template/TableTemplate'
import { ITHeadMap } from '@interfaces/ITable'
import InputCheckOwner from '@components/form/input/InputCheckOwner'
import { Link } from 'react-router-dom'
import TableAddNewButton from '@components/button/TableAddNewButton'
import { modals } from '@mantine/modals'
import { QueryObserverResult } from 'react-query'

import InputStatus from '@components/form/input/InputStatus'
import Expertise from '@api/Expertise'
import {
    IResponseGetAllExpertises,
    IResponseGetAllExpertisesRowData,
} from '@interfaces/api/IExpertise'
import TableSearchFilter from '../filter/TableSearchFilter'
const TableAllExpertise = () => {
    const [limit, setlimit] = useState(10)
    const [orderby, setorderby] =
        useState<keyof IResponseGetAllExpertisesRowData>('expertise_id')
    const [order, setorder] = useState('desc')
    const [page, setpage] = useState(1)
    const [search, setsearch] = useState('')
    const [status, setstatus] = useState('')

    const [checkowner, setcheckowner] = useState(0)
    const lists = Expertise.useGetAllExpertise({
        limit,
        orderby,
        order,
        page,
        search,
        checkowner,
        status,
    })

    useEffect(() => {
        lists.refetch()
        // eslint-disable-next-line
    }, [status, page, limit, order, orderby, checkowner])

    const thead: ITHeadMap<IResponseGetAllExpertisesRowData>[] = [
        {
            sortkey: 'expertise_name',
            label: 'ความเชี่ยวชาญ',
            width: '70%',
        },

        {
            sortkey: 'status',
            label: 'สถานะ',
            width: '20%',
        },
        // {
        //     sortkey: 'created_at',
        //     label: 'สร้างเมื่อ',
        //     width: '11%',
        // },
        // {
        //     sortkey: 'updated_at',
        //     label: 'แก้ไขล่าสุด',
        //     width: '11%',
        // },
        {
            label: 'Action',
            width: '10%',
        },
    ]

    return (
        <>
            <Flex gap='md' direction={{ xs: 'column', lg: 'row' }}>
                <TableSearchFilter
                    page={page}
                    setpage={setpage}
                    setsearch={setsearch}
                    search={search}
                    refresh={lists.refetch}
                />
                <InputCheckOwner
                    miw='180px'
                    w='100%'
                    value={String(checkowner)}
                    onChange={(value) => {
                        if (value !== String(checkowner)) {
                            setcheckowner(Number(value))
                            setpage(1)
                        }
                    }}
                />
                <InputStatus
                    withAll
                    miw='180px'
                    value={String(status)}
                    onChange={(value) => {
                        if (value !== status) {
                            setstatus(String(value))
                            setpage(1)
                        }
                    }}
                />

                <TableAddNewButton
                    component={Link}
                    to='/expertises/create'
                    label='เพิ่มความเชี่ยวชาญ'
                />
            </Flex>

            <TableTemplate<IResponseGetAllExpertisesRowData>
                thead={thead}
                orderby={orderby}
                order={order}
                setorder={setorder}
                setorderby={setorderby}
                lists={lists?.data?.lists}
            >
                {lists?.data?.lists.map((value) => (
                    <AllLecturerTableRow
                        key={value.expertise_id}
                        data={value}
                        refreshTable={lists.refetch}
                    />
                ))}
            </TableTemplate>
            {lists.data?.lists.length ? (
                <TablePagination
                    limit={lists.data?.lists.length}
                    setlimit={setlimit}
                    setpage={setpage}
                    page={page}
                    totalPages={lists.data.totalPages}
                    totalRows={lists.data.totalRows}
                />
            ) : (
                <></>
            )}
        </>
    )
}

export default TableAllExpertise

const AllLecturerTableRow = ({
    data,
    refreshTable,
}: {
    data: IResponseGetAllExpertisesRowData
    refreshTable: () => Promise<
        QueryObserverResult<IResponseGetAllExpertises, unknown>
    >
}) => {
    const Delete = Expertise.useDeleteExpertise({
        expertise_id: data.expertise_id,
        aftersuccess: refreshTable,
    })

    const openDeleteConfirmModal = () =>
        modals.openConfirmModal({
            title: 'กรุณายืนยันการลบ',
            children: (
                <Text>
                    ลบความเชี่ยวชาญ <br />
                    {data.expertise_name}
                </Text>
            ),
            labels: { confirm: 'ยืนยัน', cancel: 'ยกเลิก' },
            onConfirm: Delete.onSubmit,
        })

    return (
        <tr key={data.expertise_id}>
            <td>{data.expertise_name}</td>
            <td>{data.status_description}</td>
            {/* <DateAndFullNameColumn
                day={data.created_at}
                fullname={data.created_by_user_fullname}
                user_id={data.created_by_user_id}
            />
            <DateAndFullNameColumn
                day={data.updated_at}
                fullname={data.updated_by_user_fullname}
                user_id={data.updated_by_user_id}
            /> */}
            <td>
                <Flex gap='xs' pos='relative'>
                    <TableViewButton
                        component={Link}
                        to={`/expertises/${data.expertise_id}/view`}
                    />
                    <TableEditButton
                        component={Link}
                        to={`/expertises/${data.expertise_id}/edit`}
                    />
                    <TableDeleteButton onClick={openDeleteConfirmModal} />
                </Flex>
            </td>
        </tr>
    )
}
